export enum EchartLegendPosition {
  None = 'None',
  Right = 'Right',
  Bottom = 'Bottom',
}
